export default {"src":"/_next/static/media/chevron-left-circle.60bee86a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};